import React from 'react';
import { LocaleContext } from '../../components/LocaleContext';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

export default function CustomerEvaluationSettings() {
  const { t } = React.useContext(LocaleContext);
  const startToolbar = (
    <div className="flex flex-column gap-1">
      <span className="text-lg font-semibold">{t('CustomerEvaluationSettings.Title')}</span>
    </div>
  );
  const rightToolbar = (
    <div className="flex items-center gap-3">
      <Button
        label={t('CustomerEvaluationList.Action.Print')}
        icon="pi pi-print"
        className="p-button-sm p-button-outlined p-2"
        onClick={() => window.print()}
      />
    </div>
  );

  return (
    <div className="flex flex-col h-[calc(100dvh-64px)]">
      <Toolbar start={startToolbar} end={rightToolbar} className="shadow-1" />
      <div className="flex-1 overflow-y-auto p-4 space-y-6 pb-10">
        <Card>
          <p className="text-sm text-gray-600">{t('CustomerEvaluationSettings.Placeholder')}</p>
        </Card>
      </div>
    </div>
  );
}
